import { EnvironmentDirectory } from './environment-directory.util';

/**
 * Renders a blocking full-screen overlay that lets the user pick which
 * backend environment the internal build should point at, and resolves with
 * the chosen directory key once "Continue" is clicked.
 *
 * Deliberately framework-free (plain DOM, no Angular): it is used from
 * src/main.ts BEFORE Angular's platform/DI/module system exists (the
 * pre-bootstrap gate for the internal build), and is reused as-is from the
 * "change environment" link on the login page after bootstrap.
 */
export function showEnvPickerOverlay(directory: EnvironmentDirectory, selectedKey: string): Promise<string> {
  return new Promise<string>((resolve) => {
    const keys = Object.keys(directory);

    const overlay = document.createElement('div');
    overlay.id = 'eshyft-internal-env-picker';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:2147483647',
      'background:rgba(15,23,42,0.92)',
      'display:flex', 'align-items:center', 'justify-content:center',
      'font-family:Roboto,Arial,sans-serif',
    ].join(';');

    const card = document.createElement('div');
    card.style.cssText = [
      'background:#fff', 'border-radius:8px', 'padding:24px 28px',
      'width:320px', 'max-width:90vw', 'box-shadow:0 10px 40px rgba(0,0,0,0.35)',
    ].join(';');

    const title = document.createElement('h2');
    title.textContent = 'Choose an environment';
    title.style.cssText = 'margin:0 0 4px;font-size:18px;color:#0f172a;';
    card.appendChild(title);

    const subtitle = document.createElement('p');
    subtitle.textContent = 'This is an internal build. Pick which backend to use.';
    subtitle.style.cssText = 'margin:0 0 16px;font-size:13px;color:#64748b;';
    card.appendChild(subtitle);

    const select = document.createElement('select');
    select.style.cssText = 'width:100%;padding:8px;font-size:14px;margin-bottom:16px;box-sizing:border-box;';
    keys.forEach((key) => {
      const option = document.createElement('option');
      option.value = key;
      option.textContent = key;
      if (key === selectedKey) option.selected = true;
      select.appendChild(option);
    });
    card.appendChild(select);

    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Continue';
    button.style.cssText = [
      'width:100%', 'padding:10px', 'font-size:14px', 'font-weight:600',
      'background:#0f172a', 'color:#fff', 'border:none', 'border-radius:6px', 'cursor:pointer',
    ].join(';');
    button.addEventListener('click', () => {
      const chosen = select.value || selectedKey;
      overlay.remove();
      resolve(chosen);
    });
    card.appendChild(button);

    overlay.appendChild(card);
    document.body.appendChild(overlay);
  });
}
